/*
|--------------------------------------------------------------------------
| Views: Article
|--------------------------------------------------------------------------
*/

/**
 * Featured Single
 * @namespace
 */
__gh__webApp.views.article = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
	
		var utilities		= __gh__webApp.utilities,
			paywall 		= __gh__webApp.paywall,
			articleJSON		= bucket.items.main[0],
			articlePage		= __gh__webApp.articlePage,
			trackArticle	= __gh__webApp.utilities.tracker.trackArticle,
			articleDOM		= "#article";
	
		
		articlePage.loadArticle.callbacks({"articleObject":articleJSON,"articleDOM":"#article"});
		if( __gh__coreData["3rdPartyData"].ads.dfp.consumerSurvey != 'true'){
			articlePage.consumerSurvey.showSurvey();
		}
		
		trackArticle.mainArticle({"articleObject":articleJSON});
		paywall.meterMainArticle(articleDOM,articleJSON);
		
	},

	"prepItemData": function(items){
		var item 						= items[0],
			relatedTypes				= [],
			relatedItems 				= item.relatedContent.items,
			firstGallery 				= true,
			firstGalleryDuplicateCheck	= false;
			
		items[0].image = {};

		//Related types array to check for related icons in view
		for(var i=0; i<relatedItems.length; i++){
			var relatedItem 			= relatedItems[i],
				type 					= relatedItem.type;
				type 					= (type == "images") ? "gallery" : type;
			var	isGallery				= (type=="gallery"),
				isMainImage				= (type=="mainImage");
				
				if(relatedItem.items.length){
					relatedTypes.push(type);
				}
				
				//Add Main image to image node for easy access			
				if (isMainImage){
					items[0].image = (relatedItem.items.length > 0) ? relatedItem.items[0] : items[0].image;
				}
				
				//Remove duplicate galleries that get added by GalleryConnectionItems
				if (isGallery && firstGalleryDuplicateCheck == relatedItem.title + relatedItem.link){
					items[0].relatedContent.items.splice(i,1);
				}
				//First Gallery
				if(relatedItem.items.length && isGallery && firstGallery){
					firstGalleryDuplicateCheck 	= relatedItem.title + relatedItem.link;
					firstGallery 				= false;
				}
		}
		items[0].relatedContent.types 			= relatedTypes;
		items[0].bylineFormat					= {};
		items[0].bylineFormat.array				= items[0].byline.filter(function(a){return a.name;}).map(function(a) {return a.name;});
		items[0].bylineFormat.commaDelimited 	= items[0].bylineFormat.array.join();

		return items;
	},
	
	/**
	 * Get a subview for the article..ie.Imagelist
	 */
	"getArticleSubView": function(bucket){
		var defaultTemplate = __gh__coreData.templateData.article.defaultTemplate,
			commonJS 		= __gh__webApp.common,
			views			= __gh__webApp.views,
			articleObject	= bucket.items.main[0],
			hasSubView		= (articleObject.subView),
			subView 		= (hasSubView) ? "article" + articleObject.subView : defaultTemplate,
			isNotArticle	= (subView != "article");
		
		bucket.assetURL 	= bucket.assetURL +"?map="+ subView;
		bucket.view.name 	= (isNotArticle) ? "buckets/article/subViews/"+ subView +"/default" : "buckets/article/default";

		if (isNotArticle && commonJS.isObjectPropertySet(views, subView + ".getSubView")){
			return views[subView].getSubView(bucket);
		}

		return bucket;
	},


	"getSubView": function(bucket){
		var items			= bucket.items.main;
		
		// Prep Article
		bucket.items.main	= this.prepItemData(items);
		bucket 				= this.getArticleSubView(bucket);

		return bucket;

	}
};